<template>
  <v-row no-gutters>
    <v-col>
      <span
        ref="editable"
        :contenteditable="editable"
        class="empty-span"
        :class="
          editable && editableBorder
            ? 'editable-border text-cursor rounded-2 px-4 py-2'
            : ''
        "
        :style="{ '--placeholder': `'${placeholder}'` }"
        @input="$emit('input', $event.target.innerText)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: String,
    editable: {
      type: Boolean,
      default: false,
    },
    editableBorder: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$refs.editable.innerText = this.value ?? "";
  },
};
</script>

<style lang="scss" scoped>
[contenteditable] {
  outline: 0 solid transparent;
  display: block;
}

span[contenteditable]:empty:focus::before,
span[contenteditable]:empty::before {
  content: var(--placeholder);
  opacity: 0.3;
}

.editable-border {
  border: 1px solid rgba(40, 17, 102, 0.99);
}
</style>
